<template>
  <div class="bindwx">
    加载中...
  </div>
</template>

<script lang="ts" setup>
import { onMounted,
  reactive,
  ref } from 'vue';
import {
  useBaseUserStore,
  useRoute,
  useRouter,
} from 'hpsfir-managebase-ui';
import { ElForm, ElMessage } from 'element-plus';
import { useApi } from '@/hooks/useApi';
import { useWx } from '@/hooks/useWx';


const wx = useWx();
const baseUserStore = useBaseUserStore();
const route = useRoute();
const router = useRouter();
const countDown = ref(0);

declare const uni: any;

const getCurrentUrl = () => {
  const { protocol, hostname, pathname } = window.location;
  return encodeURI(`${protocol}//${hostname}${pathname}`);
};

const loginCode = ref('');
const wxappid = ref('');
// 小程序appid
const weappappid = ref('');
// 小程序openid
const weappopenid = ref('');


const bindLoading = ref(false);

const back = () => {
  uni.navigateBack();
};

const handleBindWeapp = async() => {
  try {
    bindLoading.value = true;
    let res = await useApi().wxApi.registerByOpenidwx({
      weappOpenid: weappopenid.value,
      loginCode: loginCode.value,
      weappAppid: weappappid.value,
    }, {
      headers: {
        appid: wxappid.value,
      },
    });

    if (!res.data?.data?.phone) {
      throw new Error('绑定失败');
    }

    console.log(res);
    res = await useApi().wxApi.isSubscribewx({
      phone: res.data?.data?.phone,
    });

    console.log(res.data.data);
    if (res.data?.data?.isSubscribe) {
      back();
    } else {
      uni.redirectTo({
        url: '/pages/wxpage/index',
      });
    }
  } catch (error) {
    ElMessage.error('授权失败');
    back();
  } finally {
    bindLoading.value = false;
  }
};


onMounted(async() => {
  const { code, state = '', appid } = route.query;
  wxappid.value = appid as string;
  loginCode.value = code as string;
  document.title = '绑定公众号';


  /*   if (baseUserStore.token) {
    back();
    return;
  } */


  const currentUrl = getCurrentUrl();
  if (!code) {
    const res = await useApi().wxApi.getWxOpenAppidwx();


    window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${
      currentUrl
    }&response_type=code&state=${state}&scope=snsapi_userinfo&component_appid=${res.data.data}#wechat_redirect`);
    return;
  }

  if (!state) {
    back();
    return;
  }

  const queryStr = (state as string);
  const inx = queryStr.indexOf('_');
  weappappid.value = queryStr.slice(0, inx);
  weappopenid.value = queryStr.slice(inx + 1);

  handleBindWeapp();
});

</script>

<style lang="scss" scoped>
.bindwx {
  box-sizing: border-box;
  padding: 16px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;

  h1 {
    color: #006cb2;
  }

  &-phone {
    display: flex;
    gap: 16px;
  }
}

</style>
